export type NewsroomItem = {
  slug: string
  date: string
  title: string
  href: string
  external?: boolean
  featured?: boolean
  subtitle?: string
  excerpt?: string
  location?: string
}

export const newsroomItems: NewsroomItem[] = [
  {
    slug: 'cnbc-ai-agents-wall-street',
    date: '2026-07-28',
    title: 'The future of Wall Street is here as startups and brokers build AI agents to trade 24/7',
    subtitle: 'CNBC',
    href: 'https://www.cnbc.com/2026/07/28/ai-agents-build-to-trade-24/7-the-future-of-wall-street.html',
    external: true,
    featured: true,
    excerpt:
      'CNBC coverage on agentic trading highlights Podium Markets AI and Ivy alongside brokerages building AI-assisted investing workflows.',
  },
]

export function pickFeaturedNewsroomItem(items: NewsroomItem[]): NewsroomItem | null {
  return items.find((item) => item.featured) ?? items[0] ?? null
}

export const featuredNewsroomItem = pickFeaturedNewsroomItem(newsroomItems)
